export default class ApiError {
	status: number
	message: any

	constructor(status: number, message: string) {
		this.status = status
		this.message = message
	}

	toString() {
		return this.message
	}
}
